import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link, Separator } from './styles';

const Title = styled.h1`
  color: ${props => props.theme.bodyColor};
  margin-bottom: 10px;
`;

const Description = styled.span`
  font-size: 18px;
  color: ${props => props.theme.secondaryColor};
  margin-left: 20px;
`;

export default function Header({ type, profile }) {
  const positionAndOrganisation = _.join(_.compact([profile.position, profile.organization]), ', ');

  return (
    <>
      <Title>
        {`Profile ${type}   |   `}
        <Link href={`/admin/profiles/${profile.slug}`}>{profile.name}</Link>
        {positionAndOrganisation && <Description>{positionAndOrganisation}</Description>}
      </Title>
      <Separator />
    </>
  );
}

Header.propTypes = {
  type: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    position: PropTypes.string,
    organization: PropTypes.string,
  }).isRequired,
};
